import { useTranslation } from 'react-i18next'

import StatisticCard from 'adminDashboard/common/statisticCard'

import { GetBenefitUsageDetailsCategoryUsage } from 'core/application/adminDashboard/reimbursements/perks/getBenefitUsageDetails'

import useCarousel from 'common/hooks/useCarousel'

import { Button, Card, Carousel, Icon } from 'common/components'

import { formatMoney } from '../../../../common'

type TotalExpenseStatisticProps = {
  data: GetBenefitUsageDetailsCategoryUsage[]
  offerSameAllowance: boolean
}

const TotalExpenseStatistic = ({ data, offerSameAllowance }: TotalExpenseStatisticProps) => {
  const { t } = useTranslation(['ee-dashboard', 'translation'])

  const dataLenght = data?.length

  const { carouselRef, currentSlideIndex, slidesNumber, goToNextSlide, goToPreviousSlide, handleCurrentSlideIndex } =
    useCarousel(dataLenght)

  return (
    <>
      {!offerSameAllowance && (
        <div className="w-100 h-100 pb-16">
          <Card className="statistic-ant-card">
            <h5 className="mb-16">{t('home.perks.totalExpenseStatistic-spending-by-perk-title')}</h5>

            <Carousel
              carouselRef={carouselRef}
              slidesToShow={dataLenght > 3 ? 3.4 : 3}
              slidesToScroll={3}
              infinite={false}
              className="mb-8 m-8-negative"
              dots={false}
              swipeToSlide
              afterChange={handleCurrentSlideIndex}
              responsive={[
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ]}
            >
              {data.map((item) => (
                <StatisticCard
                  data={[
                    {
                      type: 'Data',
                      value: (item.allowanceUsed / item.totalAllowance) * 100,
                      color: item.color,
                    },
                  ]}
                  statistics={{
                    title: item.categoryName,
                    content: formatMoney(item.percentageUsed, false),
                  }}
                  allowance={{
                    spent: item.allowanceUsed,
                    total: item.totalAllowance,
                  }}
                  offerSameAllowance={item.offerSameAllowance}
                />
              ))}
            </Carousel>

            <div className="category-spending__footer">
              <div className="flex">
                <Button
                  className="mr-8"
                  size="default"
                  htmlType="button"
                  type="default"
                  disabled={currentSlideIndex === 0}
                  onClick={goToPreviousSlide}
                >
                  <Icon type="fa fa-arrow-left" fontAwesome />
                </Button>
                <Button
                  size="default"
                  htmlType="button"
                  type="default"
                  disabled={currentSlideIndex + slidesNumber === dataLenght}
                  onClick={goToNextSlide}
                >
                  <Icon type="fa fa-arrow-right" fontAwesome />
                </Button>
              </div>

              {/*
          <p className="category-spending__footer-indicator">Showing {carouselArray}of 7 total perks</p>
*/}
            </div>
          </Card>
        </div>
      )}
    </>
  )
}

export default TotalExpenseStatistic
